import React from 'react';

const PageViewer: React.FC = () => {
  return (
    <main className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="max-w-3xl text-center">
        <h1 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-4">
          Dynamic Page Viewer
        </h1>
        <p className="text-sm md:text-base text-gray-300 leading-relaxed">
          This page is reserved for dynamic content. The 3D viewer that was here before
          depended on a missing library, so it has been replaced with this stable layout
          to keep your site running smoothly.
        </p>
      </div>
    </main>
  );
};

export default PageViewer;
